<template>
  <div class="box-column">
    <div class="column-title">
      {{ props.title }}
      <p @click="lookMore">
        查看更多
        <el-icon><ArrowRight /></el-icon>
      </p>
    </div>
    <div
      class="column-content"
      :class="{ 'ele-have-scrollbar': props.ele_have_scrollbar }"
    >
      <ul>
        <li
          class="my-li hover-change-color"
          v-for="(item, index) in props.info"
          :key="index"
          @click="goInfoPage(item.id)"
        >
          <p>{{ item.title }}</p>

          <!-- <p>{{ item.title }}</p> -->
          <p class="hover-change-color">
            {{ item.create_time.slice(0, 10) }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { ArrowRight } from "@element-plus/icons-vue";
import { useRouter } from "vue-router";

const router = useRouter();

// const mydata = reactive({
//     title:""
// })
const props = defineProps({
  title: {
    type: String,
    default: "标题",
  },
  path: {
    type: String,
    default: "",
  },
  pathDetail: {
    type: String,
    default: "",
  },
  routeQuery: {
    type: Object,
    default: () => {
      return {};
    },
  },
  ele_have_scrollbar: {
    type: Boolean,
    default: false,
  },
  info: {
    type: Array,
    default: () => {
      return {};
    },
  },
});

function lookMore() {
  // console.log(props.path);

  router.push({ path: props.path, query: props.routeQuery });
}

function goInfoPage(id) {
  router.push({
    path: props.pathDetail,
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.box-column {
  width: 375px;
  // height:232px;
  // border:1px solid red;
  padding: 16px;
  height: 100% !important;
  background-color: #fff;
  box-shadow: 0px 5px 40px 0px rgba(0, 0, 0, 0.0509803922);
  overflow: hidden;
  // border-radius: 8px;

  > .column-title {
    // width:calc(320px - 36px);
    // height:50px;
    border-bottom: 1px dashed #cccccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333333;
    font-size: 16px;
    font-weight: 700;
    padding-bottom: 11px;
    > p {
      color: #999999;
      font-size: 14px;
      font-weight: 400;
      display: flex;
      align-items: center;

      cursor: pointer;
    }
    > p:hover {
      color: #009de0;
    }
  }

  > .column-content {
    height: 200px;
    margin-top: 17px;
    // overflow: auto;
    // overflow-x: hidden;
    // overflow-y: auto;
    // margin-bottom:23px;
    // min-height:232px;
    // height:100%;
    // border: 1px solid blue;
    overflow: hidden;

    .my-li {
      > p {
        cursor: pointer;
        // border: 1px solid red;
      }
      > p:nth-of-type(1) {
        width: calc(100% - 100px);
        position: static !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    li {
      font-size: 14px;
      line-height: 24px;
      margin-left: 20px;
      margin-bottom: 10px;
      position: relative;
      p:nth-of-type(2) {
        font-size: 14px;
        font-weight: 400;
        color: #888888;
        position: absolute;
        right: 0px;
        top: 0px;
      }
    }
    li:nth-last-of-type(1) {
      margin-bottom: 0px;
    }

    li:hover {
      p:nth-of-type(2) {
        color: #009de0;
      }
    }
  }
}
</style>
